export default {
  metadata: {
    version: '1.0.0',
    id: 'dropdown-menu-item-1.0.0',
    name: 'JDSDropdownMenuItemMobile',
    platform: 'android'
  },
  hierarchy: {
    'root-container': [
      {
        container: [
          {
            'prefix-container': ['prefix-slot']
          },
          {
            'content-container': ['label-jds-text', 'description-jds-text']
          },
          {
            'suffix-container': ['suffix-jds-text', 'icon']
          }
        ]
      },
      {
        jds_dropdown_menu_submenu: ['menu-group-slot']
      }
    ]
  },
  base: {
    'root-container': {
      hidden: false,
      width: '{d_24}'
    },
    container: {
      hidden: false,
      'flex-direction': '{d_1}',
      'align-items': '{d_16}',
      gap: '{d_3}',
      'background-color': '{d_4}',
      width: '{d_0}',
      'padding-top': '{d_8}',
      'padding-right': '{d_9}',
      'padding-bottom': '{d_10}',
      'padding-left': '{d_11}',
      opacity: '',
      behavior: {
        hover: {
          'background-color': '{d_5}'
        },
        active: {
          'background-color': '{d_6}'
        },
        focus: {
          'border-radius': '{d_23}'
        }
      }
    },
    'menu-group-slot': {
      hidden: false
    },
    'suffix-container': {
      hidden: false
    },
    'prefix-container': {
      hidden: false,
      'align-self': '{d_17}'
    },
    'prefix-slot': {
      hidden: false
    },
    'content-container': {
      hidden: false,
      flex: 1,
      overflow: 'hidden',
      'justify-content': '{d_14}',
      'align-items': '{d_15}',
      'flex-direction': '{d_2}'
    },
    icon: {
      size: '{d_19}',
      color: '{d_18}',
      value: 'ic_chevron_right',
      behavior: {
        active: {
          color: '{d_20}'
        }
      },
      hidden: true
    },
    jds_dropdown_menu_submenu: {
      hidden: true
    },
    'label-jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      behavior: {
        active: {
          color: '{text_18}'
        }
      }
    },
    'description-jds-text': {
      'font-family': '{text_167}',
      color: '{text_20}',
      'font-size': '{text_166}',
      'line-height': '{text_168}',
      'letter-spacing': '{text_169}',
      'font-weight': '{text_170}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      behavior: {
        active: {
          color: '{text_18}'
        }
      }
    },
    'suffix-jds-text': {
      'font-family': '{text_167}',
      color: '{text_21}',
      'font-size': '{text_166}',
      'line-height': '{text_168}',
      'letter-spacing': '{text_169}',
      'font-weight': '{text_170}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      behavior: {
        active: {
          color: '{text_18}'
        }
      }
    }
  },
  variant: {
    _labelTextWrap: {
      false: {
        'label-jds-text': {
          'max-lines': 1,
          maxLines: 1
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{d_22}'
        }
      }
    },
    selected: {
      true: {
        container: {
          'background-color': '{d_12}',
          behavior: {
            hover: {
              'background-color': '{d_13}'
            }
          }
        },
        icon: {
          color: '{d_21}'
        },
        'label-jds-text': {
          color: '{text_18}'
        },
        'description-jds-text': {
          color: '{text_18}'
        },
        'suffix-jds-text': {
          color: '{text_18}'
        }
      }
    },
    _hasSubMenu: {
      true: {
        icon: {
          hidden: false
        },
        'suffix-jds-text': {
          hidden: true
        }
      }
    }
  },
  api: {
    children: {
      'prefix-slot': {
        name: 'prefix',
        accepts: ['jds_image', 'jds_avatar', 'jds_icon'],
        max: 1
      },
      'menu-group-slot': {
        name: 'children',
        accepts: ['jds_dropdown_menu_group']
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    data: {
      jds_dropdown_menu_submenu: {
        offsetX: {
          type: 'string',
          name: '_offsetX'
        },
        offsetY: {
          type: 'string',
          name: '_offsetY'
        },
        children: {
          type: 'slot',
          name: 'children'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      'description-jds-text': {
        value: {
          type: 'string',
          name: 'description'
        }
      },
      'suffix-jds-text': {
        value: {
          type: 'string',
          name: 'suffix'
        }
      }
    },
    config: {
      selected: {
        values: [false, true]
      },
      disabled: {
        values: [false, true]
      },
      _hasSubMenu: {
        values: [false, true]
      },
      _labelTextWrap: {
        values: [true, false]
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'menuitem'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-haspopup': {
            name: '_ariaHaspopup',
            prop: '_hasSubMenu'
          },
          'aria-expanded': {
            name: '_ariaExpanded',
            prop: 'selected'
          }
        }
      }
    }
  }
};
